var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.363,
    height: 35.364,
    viewBox: "0 0 35.363 35.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(-1467 -1107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rahmen",
    d: "M26.132,35.364H9.231A9.242,9.242,0,0,1,0,26.132V9.231A9.242,9.242,0,0,1,9.231,0h16.9a9.242,9.242,0,0,1,9.231,9.231v16.9a9.242,9.242,0,0,1-9.231,9.231M9.231,3.025A6.214,6.214,0,0,0,3.024,9.231v16.9a6.214,6.214,0,0,0,6.207,6.207h16.9a6.214,6.214,0,0,0,6.207-6.207V9.231a6.214,6.214,0,0,0-6.207-6.207Z",
    transform: "translate(1467 1107)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "facebook-2",
    "data-name": "facebook",
    d: "M12.953,4.245V0H9.2A5.388,5.388,0,0,0,3.813,5.388V9.271H0V13.7H3.813V24.059H8.468V13.634h3.486l.665-4.4H8.468V6.1a1.859,1.859,0,0,1,1.859-1.859Z",
    transform: "translate(1478 1115.305)",
    fill: "#73c9e2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5ae403e589642838b575bfec70bf01e9.svg";
export { ForwardRef as ReactComponent };